/* HomLoom: keeps the free Mystery Box in the cart in sync with the offer
   (added when the cart earns it, removed when it doesn't, max 1).
   The rule is computed in snippets/hl-cart-journey.liquid -> [data-hl-gift-state] */
(function () {
if (window.__hlGift) return; window.__hlGift = true;
var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
var busy = false, last = '';
function post(url, body) {
  return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
}
function refresh() { return window.hlCartRefresh ? window.hlCartRefresh() : Promise.resolve(); }
function sync() {
  if (busy) return;
  var el = document.querySelector('#CartDrawer [data-hl-gift-state]');
  if (!el) return;
  var ok = el.getAttribute('data-ok') === 'true', qty = Number(el.getAttribute('data-qty')) || 0, key = el.getAttribute('data-key'), vid = Number(el.getAttribute('data-vid')) || 0, sig = el.getAttribute('data-hl-sig');
  var job = null;
  if (ok && qty === 0 && vid) job = function () { return post('cart/add.js', { items: [{ id: vid, quantity: 1, properties: { _hl_gift: '1' } }] }); };
  else if (!ok && qty > 0 && key) job = function () { return post('cart/change.js', { id: key, quantity: 0 }); };
  else if (ok && qty > 1 && key) job = function () { return post('cart/change.js', { id: key, quantity: 1 }); };
  if (!job) { last = ''; return; }
  var want = sig + '|' + ok + '|' + qty;
  if (want === last) return; // same state already handled once: never loop
  last = want; busy = true;
  // make sure the drawer is not stale before changing anything
  fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
    if (c.item_count + '-' + c.total_price !== sig) { last = ''; return refresh(); }
    return job().then(refresh);
  }).catch(function () {}).then(function () { setTimeout(function () { busy = false; }, 400); });
}
var t;
function soon() { clearTimeout(t); t = setTimeout(sync, 200); }
function watch() {
  // after every cart refresh + a light poll (the drawer markup can be swapped by the theme/apps)
  var orig = window.hlCartRefresh;
  if (orig && !orig.__hlGift) { window.hlCartRefresh = function () { return orig.apply(this, arguments).then(function (x) { soon(); return x; }); }; window.hlCartRefresh.__hlGift = true; }
  if (!watch.on) { watch.on = true; setInterval(function () { if (window.hlCartRefresh && !window.hlCartRefresh.__hlGift) watch(); sync(); }, 1500); setTimeout(sync, 600); }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();